
import VIframe from '@koumoul/v-iframe'
import { mapState } from 'vuex'

export default {
  components: { VIframe },
  props: ['dataset'],
  data: () => ({
    dialog: false
  }),
  computed: {
    ...mapState(['env']),
    iframeSrc () {
      return `${this.env.publicUrl}/embed/dataset/${this.dataset.id}/table?display=${this.$vuetify.breakpoint.smAndDown ? 'list' : 'table'}`
    }
  }
}
